export default "__VITE_ASSET___aHN5WmV__"